export const constants = {
  ROLE: {
    ADMIN: "admin",
    USER: "user",
  },
  USER_ID: "userid",
  MAC_ADDRESS_REGEX:
    /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})|([0-9A-F]{4}\\.[0-9A-F]{4}\\.[0-9A-F]{4})$/,
  EMAIL_REGEX: /^[a-z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
};
